import { Button, useToggle } from '@factorialco/deprecated-design-system'

import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'
import type { Option } from 'modules/core/components/Popover/Content'

interface Props {
  options: Option[]
}

const Actions = ({ options }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <Popover attachment="top right" open={open} targetAttachment="bottom center" toggle={toggle}>
      <Button type="secondary" onClick={toggle(true)} iconName="ellipsis" />
      <PopoverContent onClose={toggle(false)} options={options} />
    </Popover>
  )
}

export default Actions
